import React from 'react';
import moment from 'moment/moment';
import { UseCurrencyDecorator } from '../../../../../utilities/hooks/UseCurrencyDecorator';
import { useProviderCurrency } from '../../../../../utilities/hooks/useProviderCurrency';
import PropTypes from 'prop-types';
import { AmountFormatHelper } from '../../../../../utilities/helpers/AmountFormatHelper';

const BookingItem = ({ item }) => {
	const decorator = UseCurrencyDecorator();
	const currency = useProviderCurrency();

	function capitalize(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	return (
		<tr>
			<td>
				<div className="booking-number">
					{moment(item.created_on *1000).format('MMM Do YYYY')}
				</div>
			</td>
			<td>{ capitalize(item.type) }</td>
			<td>{item.description}</td>
			<td>
				{ (item.amount) ? decorator(AmountFormatHelper.formatAmount(item.amount), currency) : '-' }
			</td>
			<td>
				{item.fee ? (
					<span>{ '-'+decorator(AmountFormatHelper.formatAmount(item.fee), currency) }</span>
				) : (
					<span style={{ display: 'block', textAlign: 'center', width: '40%' }}>-</span>
				)}
			</td>
			<td style={{ background: 'white'}}>
				{item.balance ? (
					<span>{decorator(AmountFormatHelper.formatAmount(item.balance), currency)}</span>
				) : (
					<span style={{ display: 'block', textAlign: 'center', width: '40%' }}>-</span>
				)}
			</td>
		</tr>
	);
};

BookingItem.propTypes = {
	item: PropTypes.object.isRequired
};

export default BookingItem;
